import { render, staticRenderFns } from "./update-config-onboarding.vue?vue&type=template&id=243487b8&scoped=true&"
import script from "./update-config-onboarding.vue?vue&type=script&lang=js&"
export * from "./update-config-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./update-config-onboarding.vue?vue&type=style&index=0&id=243487b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243487b8",
  null
  
)

export default component.exports